<div
  *transloco="let t"
  class="range-input-component"
  [class.ssr]="!isBrowser"
  [class.rtl]="direction === 'rtl'">
  <div class="display-amount" *ngIf="isBrowser && showAmountLabel">
    <span *ngIf="minReached && maxReached">{{ t('hint_any') }}</span>
    <span *ngIf="minReached && !maxReached">{{ emptyAmount | amount }}</span>
    <span *ngIf="!minReached">{{ selectedMinAmount | amount }}</span>
    <span *ngIf="!(minReached && maxReached)">{{ ' - ' }}</span>
    <span *ngIf="maxReached && !(minReached && maxReached)">{{ maxAmountLabel }}</span>
    <span *ngIf="!maxReached">{{ selectedMaxAmount | amount }}</span>
  </div>
  <div class="slider-wrapper">
    <div
      #rangeSlider
      class="noui-slider"
      [style.opacity]="isBrowser ? 1.0 : 0.0"
      [attr.aria-label]="ariaLabel || ''"></div>
  </div>
</div>
